import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';
import { number } from '@iwentsourcing/core/typing/number.js';
import { TypeOf } from '@iwentsourcing/core/typing/type-of.js';

export const JwtSessionData = object('JwtSessionData', {
  realm: string(),
  tenant: string(),
  provider: string(),
  accessToken: string(),
  refreshToken: string(),
  username: string(),
  exp: number(),
});
export type JwtSessionData = TypeOf<typeof JwtSessionData>;
